import React from "react";

import { motion } from "framer-motion";

import { SidePanelNavContext } from "~/calendar/SidePanel";
import { dispatchAnalyticsTrack } from "~/lib/segment";

import { ReactComponent as PanelToggleIconClosed } from "./panel-toggle-closed.svg";
import { ReactComponent as PanelToggleIconOpen } from "./panel-toggle-open.svg";

import styles from "./RightToolbar.module.css";

export default function PanelToggler() {
	const { navState, navStateDispatch } = React.useContext(SidePanelNavContext);
	const togglePanel = React.useCallback(() => {
		let nextState;
		if (navState.mode === "closed") {
			nextState = "opened";
			navStateDispatch({ type: "opened" });
		} else {
			nextState = "closed";
			navStateDispatch({ type: "closed" });
		}

		dispatchAnalyticsTrack("Calendar side panel action", { feature: "Calendar", nextState });
	}, [navState, navStateDispatch]);

	return (
		<motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 0.2 }}>
			<button
				title={navState.mode === "closed" ? "Open side panel" : "Close side panel"}
				onClick={togglePanel}
				className={styles.panelToggleButton}
			>
				{navState.mode === "closed" ? <PanelToggleIconClosed /> : <PanelToggleIconOpen />}
			</button>
		</motion.span>
	);
}
